import { useState } from 'react';
import { Row, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';

interface IProcedureOptionProps {
  label: string;
  isSelected: boolean;
  isDisabled: boolean;
  onToggle: () => void;
  testId?: string;
}

export const ProcedureOption = ({
  label,
  isSelected,
  isDisabled,
  onToggle,
  testId,
}: IProcedureOptionProps) => {
  const [isHovered, setIsHovered] = useState(false);

  const showHoverBorder = isHovered && !isSelected && !isDisabled;

  const handleClick = () => {
    if (!isDisabled) {
      onToggle();
    }
  };

  const getBorderColor = () => {
    if (isSelected || showHoverBorder) return colors.secondary[500];
    return colors.neutral[100];
  };

  const getTextColor = () => {
    if (isDisabled) return colors.neutral[300];
    return colors.neutral[600];
  };

  return (
    <Row
      data-testid={testId}
      data-cy={testId}
      role="button"
      tabIndex={isDisabled ? -1 : 0}
      aria-pressed={isSelected}
      aria-disabled={isDisabled}
      align="center"
      onClick={handleClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onKeyDown={(e) => {
        if ((e.key === 'Enter' || e.key === ' ') && !isDisabled) {
          e.preventDefault();
          onToggle();
        }
      }}
      style={{
        width: 325,
        borderRadius: 24,
        padding: '6.75px 20px',
        backgroundColor: isSelected ? colors.primary[50] : colors.shades[0],
        border: `1.5px solid ${getBorderColor()}`,
        cursor: isDisabled ? 'default' : 'pointer',
        transition: 'border-color 0.15s, background-color 0.15s',
      }}
    >
      <Typography as="span" variant="body1" style={{ color: getTextColor() }}>
        {label}
      </Typography>
    </Row>
  );
};
